import { render, staticRenderFns } from "./DdJitsuUnsoTaiseiKanriEdit.vue?vue&type=template&id=460d08d7&scoped=true&"
import script from "./DdJitsuUnsoTaiseiKanriEdit.vue?vue&type=script&lang=js&"
export * from "./DdJitsuUnsoTaiseiKanriEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460d08d7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRadioGroup,VRow})
